import $ from 'jquery';

import Error from './error';
import Confirmer from './confirm';

import ApplicationFormBase from './application-form-base';

class RegistrationApplication extends ApplicationFormBase {
	
	constructor() {
		super();

		// confirm delete 
		$(".delete-application").each((i, a) => {
			$(a).click(e => {
				e.preventDefault();
				let div = $("<div></div>").html($("<p></p>").html("Are you sure you want to delete this product? you <strong>CANNOT</strong> undo this operation").addClass("alert alert-danger"));

				$(div).append($("<p></p>").html("If you are sure, please write the word <code>DELETE</code> in the field below"));

				let inp = $("<input />").addClass("form-control");

				$(div).append(inp);
				let url = $(a).attr("href");

				new Confirmer().modal("Are you sure?", div, result => {
					if ($(inp).val() == "DELETE") {
						window.location = url;
					}
				})
			});
		});

		Vue.component('client-display',  () => import('../components/ClientDisplay.vue'));
		Vue.component('company-type',  () => import('../components/CompanyType.vue'));

		if ($("#registration-application").length > 0) {

		   
		}
		

		if ($("#injected_form").length > 0) {
			let parent = $("#injected_form").parent();
			try {
				this.init(window.applicationData);
			} catch(ex) {
				// form not found...
			}

			let cover = $("<div></div>").addClass("cover");
			let button = $("<button></button>").addClass("btn btn-primary btn-lg").html("Click here to unlock form and edit").click(e => {
				e.preventDefault();
				$(cover).remove();
			})
			$(cover).html(button);

			$(parent).addClass("adminForm").append(cover);

		}
		
	}

	extraData() {
		return {admin: true};
	}

	requiresTerms() {
		return false;
	}

	save(initial, contents, draft) {

		$("#form_application").val(JSON.stringify(contents));

		$("#main_form").submit();

	}


	

	getClient(id) {
		if (window.userInfo == undefined || window.userInfo.userclients == undefined) {
			return null;
		}

		// find the client.
		let client = null;
		$(window.userInfo.userclients).each((i, c) => {
			if (c.id == id) {
				client = c;
			}
		});

		return client;
	}


}

export default RegistrationApplication;
